import { IconProps } from "../../types/utils";

const Selected = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.9167 11.3335L14.1667 20.6668L10.4167 17.1668"
      stroke={color || "#242424"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Selected;
